import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <h2 className="text-3xl font-semibold mb-4">Page Not Found</h2>
      <p className="text-xl mb-8">The page you are looking for doesn't exist or has been moved.</p>
      <Link to="/" className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600">
        Go to Home Page
      </Link>
    </div>
  );
};

export default NotFoundPage;